export class Ability {
    id:number = 0;
    name: string = '';
    title: string = '';
    active:boolean = true;
}
